import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  BrowseTypesEnum,
  Workout,
  WorkoutPlayerComponent,
} from '@kinomap-dev/ng-ui-lib';
import { Comment } from '@kinomap-dev/ng-ui-lib/lib/models/comment.model';
import { TranslateModule } from '@ngx-translate/core';
import { WorkoutService } from 'app/services/workout.service';
import {
  BehaviorSubject,
  filter,
  Observable,
  of,
  Subscription,
  switchMap,
} from 'rxjs';
import { GenericViewComponent } from '../../components/generic-view/generic-view.component';
import { FavoriteApi } from '../../api/favorite.api';
import { CommentApi } from 'app/modules/dashboard/api/comment.api';
import { CommentsHttpResult } from 'app/modules/dashboard/models/comments.model';

@Component({
  selector: 'app-workout-page',
  standalone: true,
  imports: [
    AsyncPipe,
    WorkoutPlayerComponent,
    TranslateModule,
    GenericViewComponent,
  ],
  templateUrl: './workout.component.html',
  styleUrl: './workout.component.scss',
})
export class WorkoutComponent {
  workout$: Observable<Workout> = null;
  subscriptions: Subscription[] = [];
  workoutId: number | undefined;
  comments$: BehaviorSubject<Comment[]> = new BehaviorSubject<Comment[]>([]);
  sameContributor$: Observable<Workout[]> = new Observable<Workout[]>();
  recommended$: Observable<Workout[]> = new Observable<Workout[]>();
  randomImgNumber: number = Math.floor(Math.random() * 3) + 1;

  constructor(
    private workoutService: WorkoutService,
    private route: ActivatedRoute,
    private favoriteService: FavoriteApi,
    private commentsApi: CommentApi
  ) {}

  onLikeClick(workout: Workout): void {
    const likeAction: Observable<{ data: { likes_count: number } }> =
      workout.has_liked
        ? this.workoutService.removeLike(this.workoutId)
        : this.workoutService.addLike(this.workoutId);
    this.subscriptions.push(
      likeAction.subscribe(({ data: { likes_count } }) => {
        workout.likes_count = likes_count;
        this.workout$ = of(workout);
      })
    );
  }

  getComments(): void {
    this.subscriptions.push(
      this.commentsApi
        .getCommentsWorkout(this.workoutId)
        .subscribe((comments: CommentsHttpResult) => {
          const mappedComments: Comment[] = comments.data.map((c: any) => ({
            id: c.id,
            parent_id: c.parent_id ?? null,
            body: c.body,
            user: c.user,
            reply_count: c.reply_count,
            created_at: c.created_at,
          }));
          this.comments$.next(mappedComments);
        })
    );
  }

  onFavoriteClick(workout: Workout): void {
    const favoriteAction: Observable<void> = workout.is_favorite
      ? this.favoriteService.deleteFavorite$(
          this.workoutId,
          BrowseTypesEnum.Workout
        )
      : this.favoriteService.postFavorite$(
          this.workoutId,
          BrowseTypesEnum.Workout
        );

    workout.is_favorite = !workout.is_favorite;
    this.workout$ = of(workout);
    favoriteAction.subscribe();
  }

  editWorkout(formData: any): void {
    console.log(formData);
  }

  ngOnInit(): void {
    this.workoutId = this.route.snapshot.params['workoutId'];
    this.workout$ = this.workoutService.getWorkout(this.workoutId);
    this.sameContributor$ = this.workout$.pipe(
      filter((workout: Workout) => {
        return !!workout?.author?.id;
      }),
      switchMap((workout: Workout) =>
        this.workoutService.getWorkoutByUser(workout.author.id, workout.sport)
      )
    );
  }

  ngOnDestoy(): void {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }
}
